import { css, cx } from 'emotion';

import {
	grey,
	headingSmall,
	headingLarge,
	headingXLarge,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	textBlockLarger,
	metaTable,
	detailSideBarLayout,
	formSection,
} from 'inside-out/global-styles';

export const innerStyleOrganisation = css({
	'& img': {
		display: 'block',
		maxWidth: '255px',
	},
});

export const titleStyle = cx(
	headingXLarge,
	css({
		fontSize: '36px',
		lineHeight: '42px',
		margin: '0 0 54px 0',
	})
);

export const subTitleStyle = cx(
	headingSmall,
	css({
		margin: '0 0 13px 0',
	})
);

export const locationStyle = css({
	color: grey,
	fontWeight: 300,
	fontSize: '18px',
	lineHeight: '20px',
	marginTop: 0,
	marginBottom: '18px',
});

export const metaStyle = cx(
	metaTable,
	css({
		marginBottom: '40px',
	})
);

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	position: 'relative',
});

export const bodyStyle = cx(
	textBlockLarger,
	css({
		marginBottom: '40px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
		},
	})
);

export const contactTitleStyle = cx(
	headingLarge,
	css({
		margin: '0 0 20px 0',
	})
);

export const formTitleStyle = cx(
	headingSmall,
	css({
		margin: '0 0 24px 0',
	})
);

export const formSubmitStyle = cx(
	formSection.submitButton,
	css({
		marginTop: '60px',
	})
);

export const leftSideStyle = cx(
	detailSideBarLayout.leftSide,
	css({
		width: '832px',
	})
);

export const emailStyle = css({
	textDecoration: 'none',
});



// WEBPACK FOOTER //
// ./src/page-styles/research-projects/detail/index.js